import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
@Component({
  selector: 'xilo-mono-form-viewer-intake-section',
  templateUrl: './intake-section.component.html',
  styleUrls: [
    './intake-section.component.scss',
    '../../assets/custom-theme.scss',
  ],
})
export class IntakeSectionTypeComponent extends FieldType implements OnInit {
  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);

  constructor(private route: ActivatedRoute, private router: Router) {
    super();
  }

  ngOnInit() {
    this.field.fieldGroup.forEach((field) => {
      if (field.type === 'checkbox') {
        field.templateOptions.label = '';
        if (field.templateOptions.required) field.templateOptions.text += ' *';
      }
    });
  }

  onRepeat() {
    this.field.parent.templateOptions.onAdd();
    this.field.parent.templateOptions.subIndex++;
  }

  fieldStyle(step: any) {
    if (step.templateOptions.borderBottom) {
      return { 'border-bottom': step?.templateOptions?.borderBottom };
    }
  }

  fieldClasses(step: any) {
    // Check for singleColumn in multiple possible locations with priority order
    const isSingleColumn = 
      // First check this.to (component's own template options)
      this.to?.singleColumn !== undefined ? this.to.singleColumn :
      // Then check field.parent.templateOptions (parent component's template options)
      this.field?.parent?.templateOptions?.singleColumn !== undefined ? this.field.parent.templateOptions.singleColumn :
      // Finally fall back to the step's own templateOptions
      step?.templateOptions?.singleColumn;

    return {
      'form-section': !isSingleColumn,
      'form-section-single-column': isSingleColumn,
      'align-right': step?.templateOptions?.textAlign === 'right',
      'align-left': step?.templateOptions?.textAlign === 'left',
    };
  }
}
